// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"CourseButton_actionBtn__2v5Kv","Outlined":"CourseButton_Outlined__1SWxJ"};